import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Blog } from "../../models/blog";
import { UntypedFormGroup } from "@angular/forms";
import { DASHBOARD, TYPE_LIST } from "../constants/constants";
import { Category } from "src/app/models/category";
import { Appointments } from "src/app/models/appointments";
import { CommonModule, formatDate } from "@angular/common";
import { Works } from "src/app/models/works";
import moment from "moment";
import { Billings } from "src/app/models/billings";
import { NgxSpinnerService } from "ngx-spinner";
import { Supports } from "src/app/models/supports";
import { Projects } from "src/app/models/projects";
import { News } from "src/app/models/news";
import { StartupsService } from "src/app/services/startups.service";
import { Requests } from "src/app/models/requests";
import { Startups } from "src/app/models/startups";
import { UsersService } from "src/app/services/users.service";
import { Users } from "src/app/models/users";
import { StartupsLikesService } from "src/app/services/startups_likes.service";
import { Startups_likes } from "src/app/models/startups_likes";
import { StartupsReviewService } from "src/app/services/startups_review.service";
import { Reviews } from "src/app/models/review";
import { TicketsService } from "src/app/services/tickets.service";
import { Ticket } from "src/app/models/ticket";
import { ArticleOrder } from "src/app/models/article-order";
import { ArticleOrdersService } from "src/app/services/article-orders.service";
import { RouterModule } from "@angular/router";
import { CardModule } from "primeng/card";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { TagModule } from "primeng/tag";
import { TopNavComponent } from "src/app/top-nav/top-nav.component";
import { TooltipModule } from "primeng/tooltip";

moment.locale("it");

@Component({
  standalone: true,
  selector: "app-admin-dashboard",
  templateUrl: "./admin-dashboard.component.html",
  imports: [
    CommonModule,
    RouterModule,
    CardModule,
    TableModule,
    ButtonModule,
    TagModule,
    TopNavComponent,
    TooltipModule,
  ],
})
export class AdminDashboardComponent implements OnInit {
  startups: Startups[] = [];
  likes: Startups_likes[] = [];
  reviews: Reviews[] = [];
  tickets: Ticket[] = [];
  articleOrders: ArticleOrder[] = [];
  countTickets = 0;
  countArticleOrders = 0;
  domainRatings: {
    [id: string]: {
      loading: boolean;
      rating?: number;
      error?: boolean;
    };
  } = {};
  typeList: any;
  productDialog: boolean = false;
  users: Users[] = [];
  currentUser: any;
  items: any;
  countStartups = 0;
  countClients = 0;
  countLikes = 0;
  countReviews = 0;

  request: Requests;
  pageSize = 3;
  cols: any[];
  exportColumns: any[];
  _selectedColumns: any[];
  responsiveOptions: any;

  trackByFn(index, item) {
    return item.id;
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private startupsService: StartupsService,
    private startupsLikesService: StartupsLikesService,
    private startupsReviewService: StartupsReviewService,
    private usersService: UsersService,
    private ticketsService: TicketsService,
    private articleOrdersService: ArticleOrdersService,
  ) {
    this.typeList = TYPE_LIST;
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
    this.items = DASHBOARD;
    this.responsiveOptions = [
      {
        breakpoint: "1024px",
        numVisible: 3,
        numScroll: 3,
      },
      {
        breakpoint: "768px",
        numVisible: 3,
        numScroll: 3,
      },
      {
        breakpoint: "560px",
        numVisible: 3,
        numScroll: 3,
      },
    ];
  }

  ngOnInit() {
    const userId = this.currentUser.user_id;
    this.spinner.show();
    this.getStartups();
    this.getClients();
    this.getLikes();
    this.getReviews();
    this.getTickets();
    this.getArticleOrders();
    this.cols = [{ field: "page_title", header: "Titolo" }];

    this._selectedColumns = this.cols;
    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    this.spinner.hide();
  }

  goToUrl(startup_url: any): void {
    window.open(startup_url, "_blank");
  }

  getStartups() {
    const params = {
      _start: 0,
      _limit: 6,
    };

    this.startupsService.list(params).subscribe((pData) => {
      const countStartups = this.startupsService.size;

      this.updateView(() => {
        this.startups = pData;
        this.countStartups = countStartups;
        (this.startups || []).forEach((startup) =>
          this.checkDomainRating(startup),
        );
      });
    });
  }

  checkDomainRating(startup: Startups): void {
    const domain = this.startupsService.extractDomain(startup.startup_url);
    if (!domain) {
      this.setDomainRating(startup.id, { loading: false, error: true });
      return;
    }
    this.setDomainRating(startup.id, { loading: true });
    this.startupsService.checkDomainRating(domain).subscribe({
      next: (res) => {
        this.setDomainRating(startup.id, {
          loading: false,
          rating: res?.data?.domain_rating,
        });
      },
      error: () => {
        this.setDomainRating(startup.id, { loading: false, error: true });
      },
    });
  }

  private setDomainRating(
    id: number,
    value: { loading: boolean; rating?: number; error?: boolean },
  ): void {
    this.domainRatings = { ...this.domainRatings, [id]: value };
  }

  getDomainRankGaugeBackground(rating: number): string {
    const pct = Math.max(0, Math.min(100, rating));
    return (
      `conic-gradient(transparent 0 ${pct}%, #eee ${pct}% 100%),` +
      `conic-gradient(#ff3b30 0%, #ff9500 25%, #ffcc00 50%, #90ee90 75%, #34c759 100%)`
    );
  }

  edit(request: Requests) {
    this.request = { ...request };
    this.productDialog = true;
  }

  getClients() {
    const params = {
      _start: 0,
      _limit: 7,
    };

    this.usersService.list(params).subscribe((pData) => {
      const countClients = this.usersService.size;

      this.updateView(() => {
        this.users = pData;
        this.countClients = countClients;
      });
    });
  }

  getLikes() {
    const paramsLikes = {
      _start: 0,
      _limit: 4,
    };

    this.startupsLikesService.list(paramsLikes).subscribe((pData) => {
      const countLikes = this.startupsLikesService.size;

      this.updateView(() => {
        this.likes = pData;
        this.countLikes = countLikes;
      });
    });
  }

  getReviews() {
    const paramsLikes = {
      _start: 0,
      _limit: 4,
    };

    this.startupsReviewService.list(paramsLikes).subscribe((pData) => {
      const countReviews = this.startupsReviewService.size;

      this.updateView(() => {
        this.reviews = pData;
        this.countReviews = countReviews;
      });
    });
  }

  getTickets() {
    const params = {
      _start: 0,
      _limit: 7,
      _sort: "updated_at",
      _order: "desc",
    };
    this.ticketsService.list(params).subscribe((pData) => {
      const countTickets = this.ticketsService.size;

      this.updateView(() => {
        this.tickets = pData;
        this.countTickets = countTickets;
      });
    });
  }

  getArticleOrders() {
    const params = {
      _start: 0,
      _limit: 5,
      _sort_field: "created_at",
      _sort_order: "DESC",
    };
    this.articleOrdersService.list(params).subscribe({
      next: (orders) => {
        const countArticleOrders = this.articleOrdersService.size;
        this.updateView(() => {
          this.articleOrders = orders;
          this.countArticleOrders = countArticleOrders;
        });
      },
      error: () => {
        this.updateView(() => this.articleOrders = []);
      },
    });
  }

  private updateView(update: () => void): void {
    setTimeout(() => {
      update();
      this.cdr.detectChanges();
    });
  }

  getTicketStatusSeverity(status: string): string {
    const n = (status || "").toLowerCase();
    if (n === "closed") return "success";
    if (n === "in_progress") return "warning";
    return "info";
  }

  getTicketPrioritySeverity(priority: string): string {
    const n = (priority || "").toLowerCase();
    if (n === "high") return "danger";
    if (n === "low") return "secondary";
    return "warning";
  }

  getArticleOrderSeverity(status: string): "success" | "info" | "warn" | "danger" | "secondary" {
    if (status === "published" || status === "paid") return "success";
    if (["quote_requested", "changes_requested"].includes(status)) return "warn";
    if (["payment_pending", "under_review", "accepted", "quote_sent"].includes(status)) return "info";
    return "secondary";
  }

  formatStatus(value: string): string {
    return (value || "unknown").replaceAll("_", " ");
  }

  formatTicketDate(dateValue: any): string {
    if (!dateValue) return "";
    const d = new Date(dateValue);
    return isNaN(d.getTime()) ? "" : d.toLocaleString();
  }
}
